import {
  CSpinner,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import BoxWrapper from "../../../components/ui/BoxWrapper";
import { useMutation, useQuery } from "react-query";
import { useParams } from "react-router-dom";
import apiService from "../../../service/apiService";
import { useCookie } from "../../../hooks/useCookie";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import { useToast } from "../../../hooks/useToast";
import { general } from "../../../locales/general";

export default function SpecialPercentages() {
  const params: {
    offerId?: string;
  } = useParams();
  const { toastSuccess, toastError } = useToast();
  const {
    handleSubmit,
    register: registerFormField,
    setValue: setFormFieldValue,
  } = useForm();
  const { token } = useCookie("vToken");
  const { data, isLoading } = useQuery<
    any,
    any,
    SpecialPlaceManagerCommissionsResponse,
    any
  >(
    ["getSpecialOfferPartnerPercentages", params?.offerId],
    () => {
      return apiService.MakeGetRequest(
        `specials/place-manager/${params?.offerId}/percentages`,
        token,
      );
    },
    {
      refetchOnWindowFocus: false,
    },
  );
  const updateOfferCommissionsMutation = useMutation(
    async (data: {
      items: {
        userId: string;
        placeCommission: number;
      }[];
    }) => {
      return await apiService.MakePostRequest(
        `specials/${params.offerId}/place-manager/percentages`,
        data,
        token,
        false,
      );
    },
  );

  useEffect(() => {
    if (data) {
      data.commissions.forEach((commission) => {
        setFormFieldValue(
          `commissions.${commission.user.id}`,
          commission.commission,
        );
      });
    }
  }, [data, data?.commissions, setFormFieldValue]);

  const onSubmit = (data: {
    commissions?: {
      [key: string]: string;
    };
  }) => {
    try {
      const cleanedData: {
        userId: string;
        placeCommission: number;
      }[] = [];
      for (const key in data.commissions) {
        const value = parseInt(data.commissions[key]);
        if (isNaN(value)) {
          continue;
        }
        cleanedData.push({
          userId: key,
          placeCommission: value,
        });
      }
      if (cleanedData.length === 0) {
        toastError("Veuillez renseigner au moins une commission");
        return;
      }
      updateOfferCommissionsMutation.mutate(
        {
          items: cleanedData,
        },
        {
          onSuccess: () => {
            toastSuccess("Les commissions ont été mises à jour");
            // TODO: navigate to offers page
          },
          onError: () => {
            toastError(general.fr.message.operationFailed);
          },
        },
      );
    } catch (error) {
      toastError(general.fr.message.operationFailed);
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <section>
      <h5 className="fs-4 fw-bold mb-2">Pourcentage des partenaires</h5>
      <p>
        Offre: <strong>{data?.special.title}</strong>
      </p>
      <form onSubmit={handleSubmit(onSubmit)}>
        <BoxWrapper>
          <div className="mt-3 pt-2">
            <CTable responsive>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell scope="col">Partenaire</CTableHeaderCell>
                  <CTableHeaderCell scope="col">
                    Commission (%)
                  </CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {data?.commissions.map((commission) => {
                  return (
                    <CTableRow key={commission.user.id}>
                      <CTableDataCell>
                        <div>{commission.user.fullName}</div>
                        <div>{commission.user.email}</div>
                      </CTableDataCell>
                      <CTableDataCell>
                        <input
                          type="number"
                          className="custom-input"
                          style={{ maxWidth: "400px" }}
                          {...registerFormField(
                            `commissions.${commission.user.id}`,
                          )}
                        />
                      </CTableDataCell>
                    </CTableRow>
                  );
                })}
              </CTableBody>
            </CTable>
          </div>
        </BoxWrapper>
        <div className="w-full d-flex align-items-center justify-content-center">
          <button
            type="submit"
            className="btn btn-danger red-shadow w-20 px-4 py-2 text-white"
            style={{
              minWidth: "150px",
            }}
            disabled={updateOfferCommissionsMutation.isLoading}
          >
            {updateOfferCommissionsMutation.isLoading ? (
              <div className="text-center">
                <CSpinner size="sm" />
              </div>
            ) : (
              "Enregistrer"
            )}
          </button>
        </div>
      </form>
    </section>
  );
}
